"use strict";
var Observable_1 = require('../../Observable');
var publishReplay_1 = require('../../operator/publishReplay');
Observable_1.Observable.prototype.publishReplay = publishReplay_1.publishReplay;
//# sourceMappingURL=publishReplay.js.map


//////////////////
// WEBPACK FOOTER
// /var/www/ras.universarium.org/www/~/rxjs/add/operator/publishReplay.js
// module id = ../../../../rxjs/add/operator/publishReplay.js
// module chunks = 3